module.exports = __webpack_public_path__ + "img/bg6.be331caa.png";